import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'wilson-rule-label',
  imports: [TranslatePipe],
  templateUrl: './rule-label.component.html',
  styleUrl: './rule-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RuleLabelComponent {
  @Input() customLabel!: string;
  @Input() required = false;
}
